
export default {
  name: 'FiveStarProductsMethodologySection',

  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      dataReady: true,
    }
  },

  computed: {
    backgroundImgPath() {
      return this.subCatData?.MethodologyBackground?.url
    },
    subCatData() {
      if (this.data?.length === 1) {
        console.debug('single subCat in methodology')
        return this.data[0]
      } 
      if (!this.$route?.params?.any2 && this.data?.length > 0 ) {
        return this.data[0]
      }
      return this.data?.find((item) => {
        return (item.Slug === this.$route?.params?.any2)
      })
    }

    
  },
  

}
